export interface UpdatePaymentRedirectResult {
    hasPaymentMethod: boolean;
}

export const hasValidPaymentMethod = async() : Promise<UpdatePaymentRedirectResult> =>
{
    let headers = new Headers()
    headers.append('content-type', 'text/plain')

    let res = await fetch(`/api/v1/payment-methods/has-valid-payment-method`, {
        method: 'get', credentials: 'include', headers: headers,
    })

    if (!res.ok) throw Error(res.statusText)

    let json = await res.json()

    return json as UpdatePaymentRedirectResult;
}
